module.exports = __webpack_public_path__ + "static/img/head_logo.f2fd838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head_logo.png
// module id = EOO7
// module chunks = 1